import React, { memo, forwardRef } from 'react';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import { useTranslations } from 'js/hooks/i18n';
import { isVoidElement } from 'js/utils/DOM.util';
import { getHTMLParserOptions } from 'js/utils/getHTMLParserOptions.util';

import * as Types from './types';

const I18nBare = forwardRef<HTMLElement, Types.II18nProps>(({
    className = '',
    defaultValue,
    replacers = [],
    t,
    tagName = 'span',
    tKey = ''
}, ref) => {
    const defaultTranslate = useTranslations();
    const translate = t || defaultTranslate;
    const tValue = translate(tKey, replacers, defaultValue);
    const { options } = getHTMLParserOptions({ components: {} });
    const Tag = isVoidElement(tagName) ? 'span' : tagName;

    if (!tValue) {
        return null;
    }

    return (
        <Tag ref={ref} className={className}>
            {parse(DOMPurify.sanitize(tValue, { ADD_ATTR: ['target'] }), options)}
        </Tag>
    );
});

export const I18n = memo(I18nBare);
